export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateInterval: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AppleWalletPassPayloadType = {
  __typename?: 'AppleWalletPassPayloadType';
  downloadUrl: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  passTypeIdentifier: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
};

export enum ArchivedEventsSortEnum {
  StartDate = 'START_DATE'
}

export type BankAccountType = {
  __typename?: 'BankAccountType';
  countryCode: Scalars['String']['output'];
  currencyName: Scalars['String']['output'];
  holderName: Scalars['String']['output'];
  iban: Scalars['String']['output'];
  routing?: Maybe<Scalars['String']['output']>;
};

export type BankAccountTypeInput = {
  countryCode: Scalars['String']['input'];
  currencyName: Scalars['String']['input'];
  holderName: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  routing?: InputMaybe<Scalars['String']['input']>;
};

export type BlockFilterContainerType = {
  __typename?: 'BlockFilterContainerType';
  categoryBlockFilters: Array<BlockFilterType>;
  formatBlockFilters: Array<BlockFilterType>;
  performerBlockFilters: Array<BlockFilterType>;
  placeBlockFilters: Array<BlockFilterType>;
  typeBlockFilters: Array<BlockFilterType>;
};

export type BlockFilterType = {
  __typename?: 'BlockFilterType';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type CartItemAvailabilityProxyType = {
  __typename?: 'CartItemAvailabilityProxyType';
  availableQuantity: Scalars['Int']['output'];
  lineTotal?: Maybe<Scalars['Float']['output']>;
  requestedQuantity: Scalars['Int']['output'];
  requestedTicketId: Scalars['Int']['output'];
  serviceFee?: Maybe<Scalars['Float']['output']>;
  status: CartItemAvailabilityStatusEnum;
  ticket?: Maybe<TicketProxyType>;
};

export enum CartItemAvailabilityStatusEnum {
  Available = 'AVAILABLE',
  LimitExceeded = 'LIMIT_EXCEEDED',
  PartiallyAvailable = 'PARTIALLY_AVAILABLE',
  SalesEnded = 'SALES_ENDED',
  SalesNotStarted = 'SALES_NOT_STARTED',
  SoldOut = 'SOLD_OUT',
  TicketNotFound = 'TICKET_NOT_FOUND'
}

export type CartItemInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  quantity: Scalars['Int']['input'];
  ticketId: Scalars['Int']['input'];
};

export type CartPriceInfoProxyType = {
  __typename?: 'CartPriceInfoProxyType';
  promoCode?: Maybe<Scalars['String']['output']>;
  promoCodeApplied: Scalars['Boolean']['output'];
  promoCodeError?: Maybe<Scalars['String']['output']>;
  promoDiscountAmount?: Maybe<Scalars['Float']['output']>;
  promoDiscountValue?: Maybe<Scalars['Int']['output']>;
  ticketsPriceBeforePromo: Scalars['Float']['output'];
  totalNumberOfTickets: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  totalPriceBeforePromo: Scalars['Float']['output'];
  totalPriceForAllTickets: Scalars['Float']['output'];
  totalTransferFee: Scalars['Float']['output'];
};

export type CatalogFilterType = {
  __typename?: 'CatalogFilterType';
  categoriesIds: Array<Scalars['Int']['output']>;
  cityId?: Maybe<Scalars['Int']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  formatIds: Array<Scalars['Int']['output']>;
  order: OrderEnum;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  performerIds: Array<Scalars['Int']['output']>;
  period?: Maybe<PeriodEnum>;
  placeIds: Array<Scalars['Int']['output']>;
  search: Scalars['String']['output'];
  sortBy: EventSortEnum;
  typeIds: Array<Scalars['Int']['output']>;
};

export type CatalogFilterTypeInput = {
  categoriesIds?: Array<Scalars['Int']['input']>;
  cityId?: InputMaybe<Scalars['Int']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  formatIds?: Array<Scalars['Int']['input']>;
  order?: InputMaybe<OrderEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  performerIds?: Array<Scalars['Int']['input']>;
  period?: InputMaybe<PeriodEnum>;
  placeIds?: Array<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<EventSortEnum>;
  typeIds?: Array<Scalars['Int']['input']>;
};

export type CategoriesInput = {
  ids: Array<Scalars['Int']['input']>;
};

export type Category = {
  __typename?: 'Category';
  id?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CategoryProxyType = {
  __typename?: 'CategoryProxyType';
  children: Array<CategoryProxyType>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<CategoryProxyType>;
  path?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CheckpointAccessActionResponseType = {
  __typename?: 'CheckpointAccessActionResponseType';
  /** null = unlimited (Business plan), otherwise the plan's total scanner-share limit. */
  shareLimit?: Maybe<Scalars['Int']['output']>;
  totalActiveShares: Scalars['Int']['output'];
};

export type CheckpointAccessScanHistoryPaginatedType = {
  __typename?: 'CheckpointAccessScanHistoryPaginatedType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /**
   * ScanHistoryService::getScanHistoryByOrganizer() already maps entities to
   * ScanHistoryType before handing back the pagination object — no remapping here.
   */
  items: Array<ScanHistoryType>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CheckpointAccessUserSharePaginatedType = {
  __typename?: 'CheckpointAccessUserSharePaginatedType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items: Array<CheckpointAccessUserShareType>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CheckpointAccessUserShareType = {
  __typename?: 'CheckpointAccessUserShareType';
  active: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type City = {
  __typename?: 'City';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CityInput = {
  id: Scalars['Int']['input'];
};

export type CityProxyType = {
  __typename?: 'CityProxyType';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryProxyType>;
  id: Scalars['Int']['output'];
  places: Array<PlaceProxyType>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type CityType = {
  __typename?: 'CityType';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type Country = {
  __typename?: 'Country';
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  phoneCode?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type CountryCityType = {
  __typename?: 'CountryCityType';
  cityProxyType?: Maybe<CityProxyType>;
  countryProxyType?: Maybe<CountryProxyType>;
};

export type CountryInput = {
  id: Scalars['Int']['input'];
};

export type CountryProxyType = {
  __typename?: 'CountryProxyType';
  cities: Array<CityProxyType>;
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  curr?: Maybe<CurrencyProxyType>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  phoneCode?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type CountryProxyTypeCitiesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  withEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CountryType = {
  __typename?: 'CountryType';
  cities: Array<CityType>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneCode?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type CreateCartResultProxyType = {
  __typename?: 'CreateCartResultProxyType';
  cartId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  items: Array<CartItemAvailabilityProxyType>;
  success: Scalars['Boolean']['output'];
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

export type CreateOrderResultProxyType = {
  __typename?: 'CreateOrderResultProxyType';
  order: OrderProxyType;
  paymentIntent?: Maybe<PaymentIntentProxyType>;
  requiresPayment: Scalars['Boolean']['output'];
};

export type CreateOrganizerPromoCodeTypeInput = {
  code: Scalars['String']['input'];
  discountValue: Scalars['Int']['input'];
  eventIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  expirationDate: Scalars['DateTime']['input'];
  minimumOrderAmount?: InputMaybe<Scalars['Float']['input']>;
  usageLimit: Scalars['Int']['input'];
};

export type CurrencyProxyType = {
  __typename?: 'CurrencyProxyType';
  countries: Array<CountryProxyType>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum DomainStatus {
  Connected = 'CONNECTED',
  Error = 'ERROR',
  Verifying = 'VERIFYING'
}

export enum DomainType {
  Domain = 'DOMAIN',
  Subdomain = 'SUBDOMAIN',
  TicketSubdomain = 'TICKET_SUBDOMAIN'
}

export type Event = {
  __typename?: 'Event';
  description?: Maybe<Scalars['String']['output']>;
  endDateFormatted?: Maybe<Scalars['String']['output']>;
  eventVendor?: Maybe<EventVendor>;
  id?: Maybe<Scalars['Int']['output']>;
  inWishList: Scalars['Boolean']['output'];
  mainImageLink?: Maybe<Scalars['String']['output']>;
  participants?: Maybe<Array<Participant>>;
  place?: Maybe<Place>;
  slug?: Maybe<Scalars['String']['output']>;
  startDateFormatted?: Maybe<Scalars['String']['output']>;
  ticketScanned: Scalars['Int']['output'];
  ticketSoldOut: Scalars['Int']['output'];
  tickets: Array<Tickets>;
  title?: Maybe<Scalars['String']['output']>;
  totalTicketsQuantity: Scalars['Int']['output'];
  type?: Maybe<Types>;
  visual: Array<Visual>;
};


export type EventEndDateFormattedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type EventStartDateFormattedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type EventTicketScannedArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
};


export type EventTicketSoldOutArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
};

export type EventAttendeeType = {
  __typename?: 'EventAttendeeType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  paymentStatus: PaymentStatusEnum;
  phone?: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
  ticketsPrice: Scalars['Float']['output'];
  totalNumberTickets: Scalars['Int']['output'];
};

export type EventAttendeesPaginatedType = {
  __typename?: 'EventAttendeesPaginatedType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items: Array<EventAttendeeType>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EventBannerType = {
  __typename?: 'EventBannerType';
  eventId?: Maybe<Scalars['Int']['output']>;
  image: Scalars['String']['output'];
};

export enum EventBuyTypeEnum {
  CashModal = 'CASH_MODAL',
  EventIsOver = 'EVENT_IS_OVER',
  GetTickets = 'GET_TICKETS',
  NotStarted = 'NOT_STARTED',
  Preorder = 'PREORDER',
  PreorderWithDate = 'PREORDER_WITH_DATE',
  Recurring = 'RECURRING',
  RecurringWithDate = 'RECURRING_WITH_DATE',
  SoldOut = 'SOLD_OUT',
  StripeRestricted = 'STRIPE_RESTRICTED'
}

export type EventCashInfoProxyType = {
  __typename?: 'EventCashInfoProxyType';
  addresses?: Maybe<Array<Scalars['String']['output']>>;
  emails?: Maybe<Array<Scalars['String']['output']>>;
  event: EventProxyType;
  id: Scalars['Int']['output'];
  phones?: Maybe<Array<Scalars['String']['output']>>;
};

export enum EventDisplayStatusEnum {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Finished = 'FINISHED',
  Moderation = 'MODERATION',
  NeedsChanges = 'NEEDS_CHANGES',
  Paused = 'PAUSED'
}

export enum EventEditBlockReasonEnum {
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
  Finished = 'FINISHED'
}

export type EventEditabilityType = {
  __typename?: 'EventEditabilityType';
  blockReason?: Maybe<EventEditBlockReasonEnum>;
  editable: Scalars['Boolean']['output'];
};

export type EventFaqInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type EventFaqOutput = {
  __typename?: 'EventFaqOutput';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type EventFaqProxyType = {
  __typename?: 'EventFaqProxyType';
  answer: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  question: Scalars['String']['output'];
};

export type EventInfoType = {
  __typename?: 'EventInfoType';
  available: Scalars['Int']['output'];
  priceRange: Scalars['String']['output'];
  reserved: Scalars['Int']['output'];
  sold: Scalars['Int']['output'];
  totalBooked: Scalars['Int']['output'];
  totalIncome: Scalars['Float']['output'];
  totalScanned: Scalars['Int']['output'];
};

export type EventPaginatedType = {
  __typename?: 'EventPaginatedType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items: Array<EventProxyType>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EventParticipant = {
  __typename?: 'EventParticipant';
  currency?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['String']['output']>;
  eventName: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  participantPhone?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  status: Scalars['Int']['output'];
  ticketType?: Maybe<Scalars['String']['output']>;
  userMail?: Maybe<Scalars['String']['output']>;
};


export type EventParticipantEventDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type EventPaymentHistoryItemType = {
  __typename?: 'EventPaymentHistoryItemType';
  amount: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  serviceCharge: Scalars['Float']['output'];
  status: Scalars['Int']['output'];
  ticketsPrice: Scalars['Float']['output'];
  totalNumberTickets: Scalars['Int']['output'];
};

export type EventPaymentHistoryPaginatedType = {
  __typename?: 'EventPaymentHistoryPaginatedType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /**
   * Participants without an order are skipped (same as the twig page),
   * so a page may contain fewer items than itemsPerPage.
   */
  items: Array<EventPaymentHistoryItemType>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EventProxyType = {
  __typename?: 'EventProxyType';
  addedForModerationDate?: Maybe<Scalars['DateTime']['output']>;
  approveDate?: Maybe<Scalars['DateTime']['output']>;
  bannerImage?: Maybe<ImageProxyType>;
  buyType: EventBuyTypeEnum;
  cardImagePath?: Maybe<Scalars['String']['output']>;
  cartUrl: Scalars['String']['output'];
  catalogApprove: Scalars['Boolean']['output'];
  categories: Array<CategoryProxyType>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  declinedDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  displayStatus?: Maybe<EventDisplayStatusEnum>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  endDateUtc?: Maybe<Scalars['DateTime']['output']>;
  eventCashInfos: Array<EventCashInfoProxyType>;
  eventCurrency?: Maybe<Scalars['String']['output']>;
  eventInfo: EventInfoType;
  faqs: Array<EventFaqProxyType>;
  galleryImages: Array<ImageProxyType>;
  gmt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isFreeEvent: Scalars['Boolean']['output'];
  isOnceApproved: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  isParsed: Scalars['Boolean']['output'];
  isRecurring: Scalars['Boolean']['output'];
  organizer?: Maybe<OrganizerProxyType>;
  organizerPublicData: OrganizerPublicDataType;
  otherDatesEvents: Array<EventProxyType>;
  payments: Array<PaymentsProxyType>;
  performers: Array<PerformerProxyType>;
  place?: Maybe<PlaceProxyType>;
  platform?: Maybe<PlatformProxyType>;
  posterImage?: Maybe<ImageProxyType>;
  promoCodes: OrganizerPromoCodePaginatedType;
  promotionStatus?: Maybe<Scalars['Int']['output']>;
  quantitySoldOutTickets?: Maybe<Scalars['Int']['output']>;
  recurrence?: Maybe<EventRecurrenceProxyType>;
  recurringStatistic?: Maybe<Array<EventRecurrenceStatisticType>>;
  shouldShowApproveNotice: Scalars['Boolean']['output'];
  shouldShowNeedsChangesNotice: Scalars['Boolean']['output'];
  showOnMeTicket: Scalars['Boolean']['output'];
  showOnWhiteLabel: Scalars['Boolean']['output'];
  showPromoButton: Scalars['Boolean']['output'];
  showTicketOfficeButton: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  startDateUtc?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['Int']['output'];
  statusKey: EventStatusEnum;
  ticketColorsConfig?: Maybe<EventTicketConfigProxyType>;
  ticketDesignType?: Maybe<Scalars['Int']['output']>;
  ticketReturn?: Maybe<TicketReturnProxyType>;
  ticketScanned: Scalars['Int']['output'];
  ticketSoldOut: Scalars['Int']['output'];
  ticketSoldOutForUpcomingRecurringEvents: Scalars['Int']['output'];
  tickets: Array<TicketProxyType>;
  timezone?: Maybe<TimezoneProxyType>;
  title: Scalars['String']['output'];
  totalTicketsQuantity: Scalars['Int']['output'];
  types: Array<TypeProxyType>;
  views?: Maybe<Scalars['Int']['output']>;
  visual: Array<Visual>;
  youMayAlsoLikeEvents: Array<EventProxyType>;
};


export type EventProxyTypeBuyTypeArgs = {
  dateTimeString?: InputMaybe<Scalars['String']['input']>;
};


export type EventProxyTypeCartUrlArgs = {
  dateTimeString?: InputMaybe<Scalars['String']['input']>;
};


export type EventProxyTypePromoCodesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type EventRecurrenceExdateProxyType = {
  __typename?: 'EventRecurrenceExdateProxyType';
  date: Scalars['DateTime']['output'];
  dateUtc: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
};

export type EventRecurrenceInput = {
  endDate: Scalars['DateTime']['input'];
  rrule: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type EventRecurrenceProxyType = {
  __typename?: 'EventRecurrenceProxyType';
  dates: Array<RecurrenceType>;
  endDate: Scalars['DateTime']['output'];
  endDateUtc: Scalars['DateTime']['output'];
  exdates: Array<EventRecurrenceExdateProxyType>;
  humanReadableText: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  rdates: Array<EventRecurrenceRdateProxyType>;
  rrule: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  startDateUtc: Scalars['DateTime']['output'];
};


export type EventRecurrenceProxyTypeHumanReadableTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type EventRecurrenceRdateProxyType = {
  __typename?: 'EventRecurrenceRdateProxyType';
  date: Scalars['DateTime']['output'];
  dateUtc: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
};

export type EventRecurrenceStatisticType = {
  __typename?: 'EventRecurrenceStatisticType';
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  sold: Scalars['Int']['output'];
  totalIncome: Scalars['Float']['output'];
  totalScanned: Scalars['Int']['output'];
};

export type EventRecurrenceType = {
  __typename?: 'EventRecurrenceType';
  endDate: Scalars['DateTime']['output'];
  rrule: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type EventScanType = {
  __typename?: 'EventScanType';
  action?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  scanErrorReason?: Maybe<Scalars['String']['output']>;
  scannerEmail?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
  ticketCurrency?: Maybe<Scalars['String']['output']>;
  ticketPrice?: Maybe<Scalars['Int']['output']>;
  ticketTypeName?: Maybe<Scalars['String']['output']>;
};

export type EventScansPaginatedType = {
  __typename?: 'EventScansPaginatedType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items: Array<EventScanType>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum EventSortEnum {
  Date = 'DATE',
  Price = 'PRICE',
  Title = 'TITLE',
  Views = 'VIEWS'
}

export enum EventStatusEnum {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  ContinueCreating = 'CONTINUE_CREATING',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Duplicate = 'DUPLICATE',
  Moderating = 'MODERATING',
  NeedsChanges = 'NEEDS_CHANGES',
  Parsed = 'PARSED'
}

export type EventTicketConfigProxyType = {
  __typename?: 'EventTicketConfigProxyType';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  descriptionColor?: Maybe<Scalars['String']['output']>;
  mainColor?: Maybe<Scalars['String']['output']>;
  showImage?: Maybe<Scalars['Boolean']['output']>;
};

export enum EventValidationErrorEnum {
  BankAccountInfoMissing = 'BANK_ACCOUNT_INFO_MISSING',
  DescriptionTooShort = 'DESCRIPTION_TOO_SHORT',
  EventStartDateError = 'EVENT_START_DATE_ERROR',
  MainImageMissing = 'MAIN_IMAGE_MISSING',
  MissingCategory = 'MISSING_CATEGORY',
  MissingDescription = 'MISSING_DESCRIPTION',
  MissingPlace = 'MISSING_PLACE',
  MissingPlatform = 'MISSING_PLATFORM',
  MissingTitle = 'MISSING_TITLE',
  MissingType = 'MISSING_TYPE',
  NoTickets = 'NO_TICKETS',
  PaymentConfigEmpty = 'PAYMENT_CONFIG_EMPTY',
  PaymentConfigError = 'PAYMENT_CONFIG_ERROR',
  RecurringConfigError = 'RECURRING_CONFIG_ERROR',
  StripeAccountNotSubmitted = 'STRIPE_ACCOUNT_NOT_SUBMITTED',
  StripeRestricted = 'STRIPE_RESTRICTED',
  TitleTooLong = 'TITLE_TOO_LONG',
  TitleTooShort = 'TITLE_TOO_SHORT'
}

export type EventVendor = {
  __typename?: 'EventVendor';
  vendorurl?: Maybe<Scalars['String']['output']>;
};

export type EventsByCountryAndCityFilters = {
  __typename?: 'EventsByCountryAndCityFilters';
  priceRange: Array<Scalars['Float']['output']>;
  typeIds: Array<Scalars['Int']['output']>;
};

export type EventsByCountryAndCityFiltersInput = {
  priceRange?: InputMaybe<Array<Scalars['Float']['input']>>;
  typeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FrequencySaleNotificationType = {
  __typename?: 'FrequencySaleNotificationType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GeoLookupType = {
  __typename?: 'GeoLookupType';
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
};

export type GeoLookupTypeInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
};

export type HomePageBlocksType = {
  __typename?: 'HomePageBlocksType';
  banners: Array<EventBannerType>;
  newEvents: Array<EventProxyType>;
  popularPerformers: Array<PerformerProxyType>;
  topEvents: Array<EventProxyType>;
  types: Array<TypeProxyType>;
  upcomingEvents: Array<EventProxyType>;
};

export type ImagePerformer = {
  __typename?: 'ImagePerformer';
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type ImagePlace = {
  __typename?: 'ImagePlace';
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type ImageProxyType = {
  __typename?: 'ImageProxyType';
  event?: Maybe<EventProxyType>;
  fileName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  link: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type Messenger = {
  __typename?: 'Messenger';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MessengerProxyType = {
  __typename?: 'MessengerProxyType';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizers?: Maybe<Array<OrganizerProxyType>>;
  users?: Maybe<Array<UserProxyType>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Invites scanner staff by email (legacy: POST branch of checkpointAccess(),
   * EventUserShareType form + UserShareService::checkAdditionAllowed/sendCheckPointNotice).
   */
  addCheckpointAccess: CheckpointAccessActionResponseType;
  addEventToWishlist: Scalars['Boolean']['output'];
  advanceEventPromotionStatus?: Maybe<EventProxyType>;
  archiveEvent?: Maybe<EventProxyType>;
  cancelOrganizerSubscription: Scalars['Boolean']['output'];
  /**
   * Cancels a pre-order (legacy: GET
   * /for-organizers/ticket-office/ajax/canceled/pre-order/{id}).
   */
  cancelPreOrder: TicketOfficeActionResponseType;
  checkIn: EventParticipant;
  checkInParticipant: EventParticipant;
  checkOut: EventParticipant;
  clearAllOrganizerNotifications: Scalars['Boolean']['output'];
  createAppleWalletTicketPass: AppleWalletPassPayloadType;
  createBankAccount: PaymentsProxyType;
  createCart: CreateCartResultProxyType;
  createEvent: EventProxyType;
  createOrUpdatePaymentStripeAccount: StripeResponseType;
  createOrUpdatePaymentStripeAlternative: StripeAlternativeResponseType;
  createOrUpdatePaymentTicketOffice: TicketOfficeResponseType;
  createOrUpdateWhiteLabelDomain: WhiteLabelProxyType;
  createOrUpdateWhiteLabelGeneralInformation: WhiteLabelProxyType;
  createOrUpdateWhiteLabelProjectMedia: WhiteLabelConfigProxyType;
  createOrUpdateWhiteLabelSEOSettings: WhiteLabelConfigProxyType;
  createOrUpdateWhiteLabelSocialLinks: WhiteLabelConfigProxyType;
  createOrder: CreateOrderResultProxyType;
  createOrganizerPromoCode: OrganizerPromoCodeProxyType;
  createTmpToken: Scalars['String']['output'];
  deleteEvent: Scalars['Boolean']['output'];
  deleteEventAll: Scalars['Boolean']['output'];
  deleteEventBannerImage?: Maybe<EventProxyType>;
  deleteEventGalleryImage?: Maybe<EventProxyType>;
  deleteOrganizer: Scalars['Boolean']['output'];
  deleteOrganizerPromoCode: Scalars['Boolean']['output'];
  deleteTicketOffice: EventProxyType;
  deleteUser: Scalars['Boolean']['output'];
  deleteWishlist: Scalars['Boolean']['output'];
  duplicateEvent: EventProxyType;
  editUserProfile: UserProxyType;
  initiateSubscriptionPayment: Scalars['String']['output'];
  login: Token;
  loginOrganizer: Token;
  logout: Scalars['Boolean']['output'];
  logoutOrganizer: Scalars['Boolean']['output'];
  markRegistrationConversionSent: Scalars['Boolean']['output'];
  publishEvent: Array<EventValidationErrorEnum>;
  readOrganizerNotification: Scalars['Boolean']['output'];
  registration: Token;
  /** Revokes scanner access (legacy: deleteUserShare()). */
  removeCheckpointAccess: CheckpointAccessActionResponseType;
  removeOrganizerNotification: Scalars['Boolean']['output'];
  resendOrderTickets: Scalars['Boolean']['output'];
  resumeTicketSales?: Maybe<EventProxyType>;
  retryWhiteLabelDomainSetup: WhiteLabelProxyType;
  sendOrganizerVerifyEmail: Scalars['Boolean']['output'];
  /**
   * Sends (or resends) the tickets of a pre-order (legacy: GET
   * /for-organizers/ticket-office/ajax/send-tickets/pre-order/{id}).
   * Side effects are identical: StripePaymentEvent::ORDER_SUCCESS marks the
   * order as paid once and emails the tickets on every call (resend), then
   * ticketsSentAt is refreshed.
   *
   * Unlike the legacy endpoint this mutation checks event ownership
   * (agreed security fix — the legacy route only required ROLE_USER).
   */
  sendPreOrderTickets: TicketOfficeActionResponseType;
  setCategoriesUserSubscription: Scalars['Boolean']['output'];
  setPaymentStripe: StripeResponseType;
  setPerformersUserSubscription: Scalars['Boolean']['output'];
  socialLoginOrganizer: Token;
  socialLoginUser: Token;
  /**
   * Starts (or reuses) an async PDF generation job (legacy: POST
   * /for-organizers/ajax/ticket-office/ticket/{id}/start-generation).
   * Delegates to TicketOfficeService::createGenerationJob unchanged:
   * job reuse, subscription ticket limits and messenger dispatch behave
   * exactly as on the legacy endpoint.
   */
  startTicketGenerationJob: TicketGenerationJobProxyType;
  stopTicketSales?: Maybe<EventProxyType>;
  toggleEventFromWishlist: Scalars['Boolean']['output'];
  unarchiveEvent?: Maybe<EventProxyType>;
  updateEvent: EventProxyType;
  /** 5 = Event::TICKET_TYPE_DESIGN_1, 6 = Event::TICKET_TYPE_DESIGN_2 */
  updateEventTicketDesign?: Maybe<EventProxyType>;
  updateEventVisibility: EventProxyType;
  updateOrganizerProfile: OrganizerType;
  updateOrganizerPromoCode: OrganizerPromoCodeProxyType;
  uploadEventBannerImage?: Maybe<EventProxyType>;
  validateParticipant: EventParticipant;
};


export type MutationAddCheckpointAccessArgs = {
  emails: Array<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
};


export type MutationAddEventToWishlistArgs = {
  eventId: Scalars['Int']['input'];
};


export type MutationAdvanceEventPromotionStatusArgs = {
  eventId: Scalars['Int']['input'];
};


export type MutationArchiveEventArgs = {
  eventId: Scalars['Int']['input'];
};


export type MutationCancelOrganizerSubscriptionArgs = {
  subscriptionId: Scalars['Int']['input'];
};


export type MutationCancelPreOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationCheckInArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};


export type MutationCheckInParticipantArgs = {
  url: Scalars['String']['input'];
};


export type MutationCheckOutArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
};


export type MutationCreateAppleWalletTicketPassArgs = {
  ticketDataId: Scalars['Int']['input'];
};


export type MutationCreateBankAccountArgs = {
  eventId: Scalars['Int']['input'];
  input: BankAccountTypeInput;
};


export type MutationCreateCartArgs = {
  eventId: Scalars['Int']['input'];
  items: Array<CartItemInput>;
};


export type MutationCreateEventArgs = {
  banner?: InputMaybe<Scalars['Upload']['input']>;
  event: NewEventTypeInput;
  gallery?: InputMaybe<Array<Scalars['Upload']['input']>>;
  poster: Scalars['Upload']['input'];
};


export type MutationCreateOrUpdatePaymentStripeAccountArgs = {
  eventId: Scalars['Int']['input'];
  input: PaymentStripeAccountTypeInput;
  returnUrl: Scalars['String']['input'];
};


export type MutationCreateOrUpdatePaymentStripeAlternativeArgs = {
  eventId: Scalars['Int']['input'];
  input: PaymentStripeAlternativeTypeInput;
};


export type MutationCreateOrUpdatePaymentTicketOfficeArgs = {
  eventId: Scalars['Int']['input'];
  input: PaymentTicketOfficeTypeInput;
  ticketOfficeType?: InputMaybe<PaymentsTicketOfficeTypeEnum>;
};


export type MutationCreateOrUpdateWhiteLabelDomainArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  domainType: DomainType;
  whiteLabelId: Scalars['Int']['input'];
};


export type MutationCreateOrUpdateWhiteLabelGeneralInformationArgs = {
  input: WhiteLabelGeneralInformationTypeInput;
};


export type MutationCreateOrUpdateWhiteLabelProjectMediaArgs = {
  input: WhiteLabelProjectMediaTypeInput;
};


export type MutationCreateOrUpdateWhiteLabelSeoSettingsArgs = {
  input?: InputMaybe<WhiteLabelSeoSettingsTypeInput>;
};


export type MutationCreateOrUpdateWhiteLabelSocialLinksArgs = {
  input?: InputMaybe<WhiteLabelSocialLinksTypeInput>;
};


export type MutationCreateOrderArgs = {
  cartId: Scalars['String']['input'];
  participant: ParticipantInput;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  test?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateOrganizerPromoCodeArgs = {
  input: CreateOrganizerPromoCodeTypeInput;
};


export type MutationDeleteEventArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteEventBannerImageArgs = {
  eventId: Scalars['Int']['input'];
};


export type MutationDeleteEventGalleryImageArgs = {
  eventId: Scalars['Int']['input'];
  imageId: Scalars['Int']['input'];
};


export type MutationDeleteOrganizerPromoCodeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteTicketOfficeArgs = {
  eventId: Scalars['Int']['input'];
};


export type MutationDeleteWishlistArgs = {
  eventId: Scalars['Int']['input'];
};


export type MutationDuplicateEventArgs = {
  eventId: Scalars['Int']['input'];
};


export type MutationEditUserProfileArgs = {
  inputUserPassword?: InputMaybe<UserPasswordTypeInput>;
  inputUserProfile: UserProfileTypeInput;
};


export type MutationInitiateSubscriptionPaymentArgs = {
  cancelUrl: Scalars['String']['input'];
  coupon?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  plan: SubscriptionPlanEnum;
  successUrl: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLoginOrganizerArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationPublishEventArgs = {
  eventId: Scalars['Int']['input'];
};


export type MutationReadOrganizerNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRegistrationArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationRemoveCheckpointAccessArgs = {
  userShareId: Scalars['Int']['input'];
};


export type MutationRemoveOrganizerNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationResendOrderTicketsArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationResumeTicketSalesArgs = {
  eventId: Scalars['Int']['input'];
};


export type MutationRetryWhiteLabelDomainSetupArgs = {
  whiteLabelId: Scalars['Int']['input'];
};


export type MutationSendPreOrderTicketsArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationSetCategoriesUserSubscriptionArgs = {
  categoriesId: Array<Scalars['Int']['input']>;
};


export type MutationSetPaymentStripeArgs = {
  eventId: Scalars['Int']['input'];
  paymentId: Scalars['Int']['input'];
  returnUrl: Scalars['String']['input'];
};


export type MutationSetPerformersUserSubscriptionArgs = {
  performersId: Array<Scalars['Int']['input']>;
};


export type MutationSocialLoginOrganizerArgs = {
  token: Scalars['String']['input'];
  type: SocialAuthTypeEnum;
};


export type MutationSocialLoginUserArgs = {
  token: Scalars['String']['input'];
  type: SocialAuthTypeEnum;
};


export type MutationStartTicketGenerationJobArgs = {
  dt?: InputMaybe<Scalars['String']['input']>;
  separate?: InputMaybe<Scalars['Boolean']['input']>;
  ticketId: Scalars['Int']['input'];
};


export type MutationStopTicketSalesArgs = {
  eventId: Scalars['Int']['input'];
};


export type MutationToggleEventFromWishlistArgs = {
  eventId: Scalars['Int']['input'];
};


export type MutationUnarchiveEventArgs = {
  eventId: Scalars['Int']['input'];
};


export type MutationUpdateEventArgs = {
  banner?: InputMaybe<Scalars['Upload']['input']>;
  event: NewEventTypeInput;
  eventId: Scalars['Int']['input'];
  gallery?: InputMaybe<Array<Scalars['Upload']['input']>>;
  poster?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationUpdateEventTicketDesignArgs = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  descriptionColor?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
  isShowImage?: InputMaybe<Scalars['Boolean']['input']>;
  mainColor?: InputMaybe<Scalars['String']['input']>;
  ticketDesignType: Scalars['Int']['input'];
};


export type MutationUpdateEventVisibilityArgs = {
  eventId: Scalars['Int']['input'];
  showMeTicket: Scalars['Boolean']['input'];
  showWhiteLabel: Scalars['Boolean']['input'];
};


export type MutationUpdateOrganizerProfileArgs = {
  input: UpdateOrganizerProfileTypeInput;
};


export type MutationUpdateOrganizerPromoCodeArgs = {
  id: Scalars['Int']['input'];
  input: UpdateOrganizerPromoCodeTypeInput;
};


export type MutationUploadEventBannerImageArgs = {
  banner: Scalars['Upload']['input'];
  eventId: Scalars['Int']['input'];
};


export type MutationValidateParticipantArgs = {
  url: Scalars['String']['input'];
};

export enum MyEventsSortEnum {
  StartDate = 'START_DATE',
  Status = 'STATUS'
}

export type MyEventsStatusCountType = {
  __typename?: 'MyEventsStatusCountType';
  count: Scalars['Int']['output'];
  status: EventDisplayStatusEnum;
};

export type MyEventsStatusCountsType = {
  __typename?: 'MyEventsStatusCountsType';
  counts: Array<MyEventsStatusCountType>;
  total: Scalars['Int']['output'];
};

export type NewCityInput = {
  country?: InputMaybe<CountryInput>;
  name: Scalars['String']['input'];
};

export type NewCityType = {
  __typename?: 'NewCityType';
  country: Country;
  name: Scalars['String']['output'];
};

export type NewContactType = {
  __typename?: 'NewContactType';
  email: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type NewContactTypeInput = {
  email: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type NewEventType = {
  __typename?: 'NewEventType';
  categories: Array<Category>;
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  faqs?: Maybe<Array<EventFaqOutput>>;
  isOnline: Scalars['Boolean']['output'];
  isRecurring: Scalars['Boolean']['output'];
  newPerformers?: Maybe<Array<NewPerformerType>>;
  newPlace?: Maybe<NewPlaceType>;
  performers?: Maybe<Array<Performer>>;
  place?: Maybe<Place>;
  platform?: Maybe<NewPlatformType>;
  recurrence?: Maybe<EventRecurrenceType>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  ticketReturn: NewTicketReturnType;
  tickets: Array<NewTicketType>;
  timezone?: Maybe<TimeZone>;
  title: Scalars['String']['output'];
};

export type NewEventTypeInput = {
  categories: CategoriesInput;
  description: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  faqs?: InputMaybe<Array<EventFaqInput>>;
  isOnline: Scalars['Boolean']['input'];
  isRecurring: Scalars['Boolean']['input'];
  newPerformers?: InputMaybe<Array<NewPerformerTypeInput>>;
  newPlace?: InputMaybe<NewPlaceInput>;
  performers?: InputMaybe<PerformersInput>;
  place?: InputMaybe<PlaceInput>;
  platform?: InputMaybe<NewPlatformInput>;
  recurrence?: InputMaybe<EventRecurrenceInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  ticketReturn: NewTicketReturnTypeInput;
  tickets: Array<NewTicketTypeInput>;
  timezone?: InputMaybe<TimezoneInput>;
  title: Scalars['String']['input'];
};

export type NewPerformerType = {
  __typename?: 'NewPerformerType';
  name: Scalars['String']['output'];
};

export type NewPerformerTypeInput = {
  name: Scalars['String']['input'];
};

export type NewPlaceInput = {
  address: Scalars['String']['input'];
  city?: InputMaybe<CityInput>;
  name: Scalars['String']['input'];
  newCity?: InputMaybe<NewCityInput>;
};

export type NewPlaceType = {
  __typename?: 'NewPlaceType';
  address: Scalars['String']['output'];
  city?: Maybe<City>;
  name: Scalars['String']['output'];
  newCity?: Maybe<NewCityType>;
};

export type NewPlatformInput = {
  invitationLink: Scalars['String']['input'];
  platformUseGuidelines: Scalars['String']['input'];
};

export type NewPlatformType = {
  __typename?: 'NewPlatformType';
  invitationLink: Scalars['String']['output'];
  platformUseGuidelines: Scalars['String']['output'];
};

export type NewTicketReturnType = {
  __typename?: 'NewTicketReturnType';
  contacts?: Maybe<Array<NewContactType>>;
  description?: Maybe<Scalars['String']['output']>;
  isPossible: Scalars['Boolean']['output'];
};

export type NewTicketReturnTypeInput = {
  contacts?: InputMaybe<Array<NewContactTypeInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  isPossible: Scalars['Boolean']['input'];
};

export type NewTicketType = {
  __typename?: 'NewTicketType';
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTicketSales?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  limitQuantity?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  startTicketSales?: Maybe<Scalars['DateTime']['output']>;
  ticketSalesInterval?: Maybe<Scalars['DateInterval']['output']>;
  type: TicketType;
};

export type NewTicketTypeInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTicketSales?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limitQuantity?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  startTicketSales?: InputMaybe<Scalars['DateTime']['input']>;
  ticketSalesInterval?: InputMaybe<Scalars['DateInterval']['input']>;
  type: TicketTypeInput;
};

export enum OrderEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderProxyType = {
  __typename?: 'OrderProxyType';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  event?: Maybe<EventProxyType>;
  hashId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  orderTickets: Array<OrderTicketsProxyType>;
  promoCodeSnapshot?: Maybe<Scalars['String']['output']>;
  promoDiscountAmount?: Maybe<Scalars['Float']['output']>;
  promoDiscountValueSnapshot?: Maybe<Scalars['Int']['output']>;
  serviceCharge: Scalars['Float']['output'];
  status?: Maybe<Scalars['Int']['output']>;
  ticketsPrice: Scalars['Float']['output'];
  ticketsPriceBeforePromo?: Maybe<Scalars['Float']['output']>;
  totalNumberTickets: Scalars['Int']['output'];
};

export type OrderTicketDataPaginatedType = {
  __typename?: 'OrderTicketDataPaginatedType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items: Array<OrderTicketDataProxyType>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OrderTicketDataProxyType = {
  __typename?: 'OrderTicketDataProxyType';
  activatedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isScanned: Scalars['Boolean']['output'];
  orderTicket?: Maybe<OrderTicketsProxyType>;
  status?: Maybe<Scalars['Int']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type OrderTicketsProxyType = {
  __typename?: 'OrderTicketsProxyType';
  amountPerItem?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<OrderProxyType>;
  orderTicketData: Array<OrderTicketDataProxyType>;
  quantity?: Maybe<Scalars['Int']['output']>;
  ticket?: Maybe<TicketProxyType>;
};

export type OrganizerNotificationPaginatedType = {
  __typename?: 'OrganizerNotificationPaginatedType';
  items: Array<OrganizerNotificationType>;
  maxPage: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type OrganizerNotificationType = {
  __typename?: 'OrganizerNotificationType';
  createdAt?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['Int']['output']>;
  eventSlug?: Maybe<Scalars['String']['output']>;
  eventTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  type: OrganizerNotificationTypeEnum;
  wasRead: Scalars['Boolean']['output'];
};

export enum OrganizerNotificationTypeEnum {
  Custom = 'CUSTOM',
  EventModeration = 'EVENT_MODERATION',
  EventNeedChanges = 'EVENT_NEED_CHANGES',
  EventPublished = 'EVENT_PUBLISHED',
  NeedsSubscriptionRenewal = 'NEEDS_SUBSCRIPTION_RENEWAL',
  OrganizerVerificationEmail = 'ORGANIZER_VERIFICATION_EMAIL',
  ProfileMissingInfo = 'PROFILE_MISSING_INFO',
  StripeRestricted = 'STRIPE_RESTRICTED'
}

export type OrganizerPromoCodeFilterType = {
  __typename?: 'OrganizerPromoCodeFilterType';
  id?: Maybe<Scalars['Int']['output']>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
};

export type OrganizerPromoCodeFilterTypeInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizerPromoCodePaginatedType = {
  __typename?: 'OrganizerPromoCodePaginatedType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items: Array<OrganizerPromoCodeProxyType>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OrganizerPromoCodeProxyType = {
  __typename?: 'OrganizerPromoCodeProxyType';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  discountValue: Scalars['Int']['output'];
  events: Array<EventProxyType>;
  expirationDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  minimumOrderAmount?: Maybe<Scalars['Float']['output']>;
  organizer?: Maybe<OrganizerProxyType>;
  status: OrganizerPromoCodeStatusEnum;
  usageCount: Scalars['Int']['output'];
  usageLimit: Scalars['Int']['output'];
};

export enum OrganizerPromoCodeStatusEnum {
  Active = 'ACTIVE',
  Expired = 'EXPIRED'
}

export type OrganizerProxyType = {
  __typename?: 'OrganizerProxyType';
  avatar?: Maybe<Scalars['String']['output']>;
  banActive: Scalars['Boolean']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  companyWebsite?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryProxyType>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  frequencySaleNotification?: Maybe<FrequencySaleNotificationType>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  messenger?: Maybe<MessengerProxyType>;
  messengerUserName?: Maybe<Scalars['String']['output']>;
  payments: Array<PaymentsProxyType>;
  phone?: Maybe<Scalars['String']['output']>;
  promoCodes: OrganizerPromoCodePaginatedType;
  stripeStatus?: Maybe<OrganizerStripeStatusType>;
  subscription?: Maybe<SubscriptionProxyType>;
  website?: Maybe<Scalars['String']['output']>;
  whiteLabel?: Maybe<WhiteLabelProxyType>;
  whiteLabelAccess: WhiteLabelAccessType;
  whiteLabelLimitInfo: WhiteLabelLimitInfoType;
};


export type OrganizerProxyTypePaymentsArgs = {
  type?: InputMaybe<PaymentsTypeEnum>;
};


export type OrganizerProxyTypePromoCodesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizerPublicDataType = {
  __typename?: 'OrganizerPublicDataType';
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type OrganizerStripeStatusType = {
  __typename?: 'OrganizerStripeStatusType';
  eventId?: Maybe<Scalars['Int']['output']>;
  stripeStatus?: Maybe<PaymentsStripeStatusEnum>;
  verifyAccountUrl?: Maybe<Scalars['String']['output']>;
};

export type OrganizerType = {
  __typename?: 'OrganizerType';
  companyName?: Maybe<Scalars['String']['output']>;
  companyWebsite?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryType>;
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  frequencySaleNotification?: Maybe<FrequencySaleNotificationType>;
  lastName?: Maybe<Scalars['String']['output']>;
  messenger?: Maybe<Messenger>;
  messengerUserName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type Participant = {
  __typename?: 'Participant';
  email?: Maybe<Scalars['String']['output']>;
};

export type ParticipantInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type Participants = {
  __typename?: 'Participants';
  activatedAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};


export type ParticipantsActivatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentIntentCustomerProxyType = {
  __typename?: 'PaymentIntentCustomerProxyType';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type PaymentIntentProxyType = {
  __typename?: 'PaymentIntentProxyType';
  clientSecret: Scalars['String']['output'];
  customer: PaymentIntentCustomerProxyType;
  customerSessionSecret?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export enum PaymentStatusEnum {
  Free = 'FREE',
  NotPaid = 'NOT_PAID',
  Paid = 'PAID'
}

export type PaymentStripeAccountType = {
  __typename?: 'PaymentStripeAccountType';
  countryId: Scalars['Int']['output'];
  email: Scalars['String']['output'];
};

export type PaymentStripeAccountTypeInput = {
  countryId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
};

export type PaymentStripeAlternativeType = {
  __typename?: 'PaymentStripeAlternativeType';
  accountHolderName: Scalars['String']['output'];
  accountNumber?: Maybe<Scalars['String']['output']>;
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  countryId: Scalars['Int']['output'];
  countryOfTheBankAccountId: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  feePayerType: Scalars['Boolean']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  nameOfTheBank: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  postalCode: Scalars['Int']['output'];
  swiftOrBic?: Maybe<Scalars['String']['output']>;
};

export type PaymentStripeAlternativeTypeInput = {
  accountHolderName: Scalars['String']['input'];
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  countryId: Scalars['Int']['input'];
  countryOfTheBankAccountId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  feePayerType: Scalars['Boolean']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  nameOfTheBank: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  postalCode: Scalars['Int']['input'];
  swiftOrBic?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentTicketOfficeType = {
  __typename?: 'PaymentTicketOfficeType';
  addresses: Array<Scalars['String']['output']>;
  emails: Array<Scalars['String']['output']>;
  phones?: Maybe<Array<Scalars['String']['output']>>;
};

export type PaymentTicketOfficeTypeInput = {
  address: Array<Scalars['String']['input']>;
  email: Array<Scalars['String']['input']>;
  phone?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PaymentsProxyType = {
  __typename?: 'PaymentsProxyType';
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizer?: Maybe<OrganizerProxyType>;
  payoneerId?: Maybe<Scalars['String']['output']>;
  stripeAlternative?: Maybe<StripeAlternativeProxyType>;
  stripeAlternativeTransferStatus?: Maybe<Scalars['String']['output']>;
  stripeConnectBankAccountId?: Maybe<Scalars['String']['output']>;
  stripeId?: Maybe<Scalars['String']['output']>;
  stripeStatus?: Maybe<Scalars['Int']['output']>;
  /** Enum counterpart of ticketOfficeType (kept as int for backward compatibility). */
  ticketOfficeMode?: Maybe<TicketOfficeModeEnum>;
  ticketOfficeType?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum PaymentsStripeStatusEnum {
  StatusRestricted = 'STATUS_RESTRICTED',
  StatusRestrictedSoon = 'STATUS_RESTRICTED_SOON',
  StatusVerified = 'STATUS_VERIFIED'
}

export enum PaymentsTicketOfficeTypeEnum {
  GenerateTicketTicketOfficeType = 'GENERATE_TICKET_TICKET_OFFICE_TYPE',
  PreOrderTicketOfficeType = 'PRE_ORDER_TICKET_OFFICE_TYPE',
  ShowModalTicketOfficeType = 'SHOW_MODAL_TICKET_OFFICE_TYPE'
}

export enum PaymentsTypeEnum {
  CashType = 'CASH_TYPE',
  StripeAlternativeType = 'STRIPE_ALTERNATIVE_TYPE',
  StripeType = 'STRIPE_TYPE'
}

export type Performer = {
  __typename?: 'Performer';
  events: Array<Event>;
  id?: Maybe<Scalars['Int']['output']>;
  imagePerformers: Array<ImagePerformer>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type PerformerPaginatedType = {
  __typename?: 'PerformerPaginatedType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items: Array<PerformerProxyType>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PerformerProxyType = {
  __typename?: 'PerformerProxyType';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type PerformersInput = {
  ids: Array<Scalars['Int']['input']>;
};

export enum PeriodEnum {
  ThisMonth = 'THIS_MONTH',
  ThisWeek = 'THIS_WEEK',
  Today = 'TODAY',
  Tomorrow = 'TOMORROW'
}

export type PeriodsType = {
  __typename?: 'PeriodsType';
  thisMonth: Scalars['Boolean']['output'];
  thisWeek: Scalars['Boolean']['output'];
  today: Scalars['Boolean']['output'];
  tomorrow: Scalars['Boolean']['output'];
};

export type Place = {
  __typename?: 'Place';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  id?: Maybe<Scalars['Int']['output']>;
  imagePlaces?: Maybe<Array<ImagePlace>>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type PlaceInput = {
  id: Scalars['Int']['input'];
};

export type PlaceProxyType = {
  __typename?: 'PlaceProxyType';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<CityProxyType>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type Platform = {
  __typename?: 'Platform';
  id?: Maybe<Scalars['Int']['output']>;
  invitationLink?: Maybe<Scalars['String']['output']>;
  platformUseGuidelines?: Maybe<Scalars['String']['output']>;
};

export type PlatformProxyType = {
  __typename?: 'PlatformProxyType';
  event: EventProxyType;
  id: Scalars['Int']['output'];
  invitationLink?: Maybe<Scalars['String']['output']>;
  platformUseGuidelines?: Maybe<Scalars['String']['output']>;
};

export enum QrCodeFrameEnum {
  Frame_2 = 'FRAME_2',
  Frame_3 = 'FRAME_3',
  Frame_4 = 'FRAME_4',
  Frame_5 = 'FRAME_5',
  Frame_6 = 'FRAME_6',
  NoFrame = 'NO_FRAME'
}

export type Query = {
  __typename?: 'Query';
  activeSubscription: Scalars['Boolean']['output'];
  allCountries: Array<Country>;
  archivedEvents: EventPaginatedType;
  arrEventsUserShareType: Array<UserShareEventType>;
  cart: CreateCartResultProxyType;
  cartPriceInfo: CartPriceInfoProxyType;
  catalogAvailableFilters: BlockFilterContainerType;
  catalogAvailablePeriods: PeriodsType;
  catalogEvents: Array<EventProxyType>;
  categories: Array<Category>;
  categoriesProxy: Array<CategoryProxyType>;
  checkIn: EventParticipant;
  /**
   * Checks whether a promo code exists and is currently usable by this organizer.
   * Pass planId to also confirm the code is scoped to that specific plan; omit it to
   * just check the code exists and see which plans it applies to (via applicablePlans).
   */
  checkSubscriptionPromoCode: SubscriptionPromoCodeType;
  checkTicketsAvailability: Array<CartItemAvailabilityProxyType>;
  /**
   * Scan history sub-page (legacy: checkpointAccessHistory()). Unlike the existing
   * getScanHistory query, this one is properly paginated — getScanHistory is left
   * unchanged since it may already be in use by other clients.
   */
  checkpointAccessScanHistory: CheckpointAccessScanHistoryPaginatedType;
  /**
   * List of the checkpoint-access page (legacy: usersShare passed to
   * checkpoint-access.twig via UserShareRepository::findBy(['event' => $event])).
   */
  checkpointAccessUserShares: CheckpointAccessUserSharePaginatedType;
  city: Array<CityProxyType>;
  countries: Array<CountryProxyType>;
  country?: Maybe<CountryProxyType>;
  currencies: Array<CurrencyProxyType>;
  event?: Maybe<Event>;
  eventAttendees: EventAttendeesPaginatedType;
  eventEditability: EventEditabilityType;
  eventGallery: Array<Visual>;
  eventPaymentHistory: EventPaymentHistoryPaginatedType;
  eventProxy?: Maybe<EventProxyType>;
  eventQrCodeDownloadUrl: Scalars['String']['output'];
  eventScanHistory: EventScansPaginatedType;
  eventScans: EventScansPaginatedType;
  eventTickets: Array<TicketInfoType>;
  eventUserShare: UserShareEventType;
  events: Array<Event>;
  eventsHistory: Array<Event>;
  eventsWithScanHistory: Array<Event>;
  frequencySaleNotifications: Array<FrequencySaleNotificationType>;
  getCountryById?: Maybe<CountryType>;
  getEventsByCountryAndCity: Array<Event>;
  hasBusinessSubscription: Scalars['Boolean']['output'];
  hasProSubscription: Scalars['Boolean']['output'];
  homePageBlocks: HomePageBlocksType;
  /**
   * Bootstrap of the generation page (legacy: twig function
   * get_in_progress_job): resumes polling for a job already running.
   */
  inProgressTicketGenerationJob?: Maybe<TicketGenerationJobProxyType>;
  messengers: Array<MessengerProxyType>;
  myEvents: EventPaginatedType;
  myEventsStatusCounts: MyEventsStatusCountsType;
  needVerifyEmail: Scalars['Boolean']['output'];
  newOnWebsiteEvents: Array<Event>;
  order: OrderProxyType;
  organizer: OrganizerProxyType;
  organizerActiveSubscription?: Maybe<SubscriptionProxyType>;
  organizerNotifications: OrganizerNotificationPaginatedType;
  organizerProfile: OrganizerType;
  organizerPromoCodes: OrganizerPromoCodePaginatedType;
  organizerSubscriptionOrders: Array<SubscriptionOrderProxyType>;
  participantsByEvent: Array<Participants>;
  paymentCountry: StripeConnectBankAccountCountryType;
  performerById: Performer;
  performers?: Maybe<Array<Performer>>;
  performersProxy: PerformerPaginatedType;
  placesByCityId: Array<Place>;
  /**
   * Pre-order list of the pre-order page (legacy: OrderRepository::getPreOrders
   * + KNP pagination in OrganizerTicketOffice::ticketOffice).
   */
  preOrders: TicketOfficePreOrderPaginatedType;
  scanHistory: Array<ScanHistoryType>;
  scannerHasSubscription: Scalars['Boolean']['output'];
  shouldSendRegistrationConversion: Scalars['Boolean']['output'];
  stripeConnectBankAccountCountries: Array<StripeConnectBankAccountCountryType>;
  stripeCountries: Array<CountryProxyType>;
  stripeCurrencies: Array<CurrencyProxyType>;
  stripeCurrenciesByCountry: Array<CurrencyProxyType>;
  subscriptionCustomerPortalUrl: Scalars['String']['output'];
  subscriptionInvoiceUrl: Scalars['String']['output'];
  /**
   * Returns all available subscription plans with live prices from Stripe.
   * Public — no auth required. Pass a coupon to get discounted amounts for the plans it applies
   * to (an invalid/expired/unknown coupon is ignored — prices are returned undiscounted).
   */
  subscriptionPlans: Array<SubscriptionPlanPriceType>;
  /**
   * Polling endpoint of the generation flow (legacy: GET
   * /for-organizers/ajax/ticket-office/generation-job/{id}/get-generation-job).
   */
  ticketGenerationJob: TicketGenerationJobProxyType;
  /**
   * Stats table of the pre-order page (legacy: HTML fragment
   * organizer/pre-order/table.html.twig via the ticket_info twig function).
   */
  ticketOfficeTicketStats: Array<TicketOfficeTicketStatsType>;
  ticketTypesProxy: Array<TicketTypeProxyType>;
  timezonesProxy: Array<TimezoneProxyType>;
  topEvents: Array<Event>;
  types: Array<Types>;
  typesProxy: Array<TypeProxyType>;
  upcomingEvents: Array<Event>;
  userLocation: CountryCityType;
  userProfile: UserProxyType;
  userSubscription?: Maybe<UserSubscription>;
  userTickets: Array<UserTicketType>;
  userWishlist: Array<Wishlist>;
  validateParticipant: EventParticipant;
  validateUserShareToken: Scalars['Boolean']['output'];
  venueByEventId: Array<Venue>;
};


export type QueryActiveSubscriptionArgs = {
  isWhiteLabelSubscription?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryArchivedEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ArchivedEventsSortEnum>;
};


export type QueryArrEventsUserShareTypeArgs = {
  tokens: Array<Scalars['String']['input']>;
};


export type QueryCartArgs = {
  cartId: Scalars['String']['input'];
};


export type QueryCartPriceInfoArgs = {
  cartId: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalogAvailableFiltersArgs = {
  filter?: InputMaybe<CatalogFilterTypeInput>;
};


export type QueryCatalogAvailablePeriodsArgs = {
  filter?: InputMaybe<CatalogFilterTypeInput>;
};


export type QueryCatalogEventsArgs = {
  filter?: InputMaybe<CatalogFilterTypeInput>;
};


export type QueryCategoriesArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  countrySlug?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckInArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};


export type QueryCheckSubscriptionPromoCodeArgs = {
  code: Scalars['String']['input'];
  planId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckTicketsAvailabilityArgs = {
  items: Array<CartItemInput>;
};


export type QueryCheckpointAccessScanHistoryArgs = {
  eventId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckpointAccessUserSharesArgs = {
  eventId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountriesArgs = {
  withCities?: InputMaybe<Scalars['Boolean']['input']>;
  withEvents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCountryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEventArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEventAttendeesArgs = {
  dateSort?: InputMaybe<SortDirectionEnum>;
  eventId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventEditabilityArgs = {
  eventId: Scalars['Int']['input'];
};


export type QueryEventGalleryArgs = {
  eventId: Scalars['Int']['input'];
};


export type QueryEventPaymentHistoryArgs = {
  dateSort?: InputMaybe<SortDirectionEnum>;
  eventId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventProxyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEventQrCodeDownloadUrlArgs = {
  eventId: Scalars['Int']['input'];
  frame?: InputMaybe<QrCodeFrameEnum>;
};


export type QueryEventScanHistoryArgs = {
  eventId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventScansArgs = {
  eventId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventTicketsArgs = {
  eventId: Scalars['Int']['input'];
};


export type QueryEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortEventsEnum>;
};


export type QueryEventsHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCountryByIdArgs = {
  countryId: Scalars['Int']['input'];
};


export type QueryGetEventsByCountryAndCityArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  countrySlug: Scalars['String']['input'];
  endpointFilters?: InputMaybe<EventsByCountryAndCityFiltersInput>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHomePageBlocksArgs = {
  cityId?: InputMaybe<Scalars['Int']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInProgressTicketGenerationJobArgs = {
  ticketId: Scalars['Int']['input'];
};


export type QueryMyEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<MyEventsSortEnum>;
  status?: InputMaybe<EventDisplayStatusEnum>;
};


export type QueryMyEventsStatusCountsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNewOnWebsiteEventsArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  countrySlug?: InputMaybe<Scalars['String']['input']>;
  maxResult?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderArgs = {
  hashId: Scalars['String']['input'];
};


export type QueryOrganizerNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizerPromoCodesArgs = {
  filter?: InputMaybe<OrganizerPromoCodeFilterTypeInput>;
};


export type QueryParticipantsByEventArgs = {
  eventId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaymentCountryArgs = {
  countryCode: Scalars['String']['input'];
};


export type QueryPerformerByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPerformersArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  countrySlug?: InputMaybe<Scalars['String']['input']>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPerformersProxyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlacesByCityIdArgs = {
  cityId: Scalars['Int']['input'];
};


export type QueryPreOrdersArgs = {
  eventId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScanHistoryArgs = {
  eventId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStripeCurrenciesByCountryArgs = {
  countryCode: Scalars['String']['input'];
};


export type QuerySubscriptionInvoiceUrlArgs = {
  orderId: Scalars['Int']['input'];
};


export type QuerySubscriptionPlansArgs = {
  coupon?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTicketGenerationJobArgs = {
  jobId: Scalars['Int']['input'];
};


export type QueryTicketOfficeTicketStatsArgs = {
  eventId: Scalars['Int']['input'];
};


export type QueryTopEventsArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  countrySlug?: InputMaybe<Scalars['String']['input']>;
  maxResult?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUpcomingEventsArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  countrySlug?: InputMaybe<Scalars['String']['input']>;
  eventsIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  maxResult?: InputMaybe<Scalars['Int']['input']>;
  placeSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserLocationArgs = {
  input?: InputMaybe<GeoLookupTypeInput>;
};


export type QueryUserWishlistArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateParticipantArgs = {
  url: Scalars['String']['input'];
};


export type QueryValidateUserShareTokenArgs = {
  userShareToken: Scalars['String']['input'];
};


export type QueryVenueByEventIdArgs = {
  eventId: Scalars['Int']['input'];
};

export type RecurrenceType = {
  __typename?: 'RecurrenceType';
  endDate: Scalars['DateTime']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type ScanHistoryType = {
  __typename?: 'ScanHistoryType';
  action: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  scanErrorReason?: Maybe<Scalars['String']['output']>;
  scanTicketData: ScanTicketDataType;
  scannerEmail?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};


export type ScanHistoryTypeCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ScanTicketDataType = {
  __typename?: 'ScanTicketDataType';
  ticketCurrency?: Maybe<Scalars['String']['output']>;
  ticketId: Scalars['Int']['output'];
  ticketPrice?: Maybe<Scalars['Float']['output']>;
  ticketType: Scalars['String']['output'];
};

export enum SocialAuthTypeEnum {
  Apple = 'APPLE',
  Google = 'GOOGLE'
}

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortEventsEnum {
  Date = 'DATE',
  TopSales = 'TOP_SALES',
  TopScanned = 'TOP_SCANNED'
}

export type StripeAlternativeProxyType = {
  __typename?: 'StripeAlternativeProxyType';
  accountHolderName?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  feePayerType?: Maybe<Scalars['Int']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  nameOfTheBank?: Maybe<Scalars['String']['output']>;
  payments: Array<PaymentsProxyType>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  serviceFee: Scalars['Float']['output'];
  swiftOrBic?: Maybe<Scalars['String']['output']>;
};

export type StripeAlternativeResponseType = {
  __typename?: 'StripeAlternativeResponseType';
  paymentsProxyType: PaymentsProxyType;
  stripeAlternativeProxyType: StripeAlternativeProxyType;
};

export type StripeConnectBankAccountCountryType = {
  __typename?: 'StripeConnectBankAccountCountryType';
  countryCode: Scalars['String']['output'];
  currencies: Array<Scalars['String']['output']>;
  iban: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  number: Scalars['Boolean']['output'];
  routing: Scalars['Boolean']['output'];
  swift: Scalars['Boolean']['output'];
};

export type StripeResponseType = {
  __typename?: 'StripeResponseType';
  paymentsProxyType: PaymentsProxyType;
  redirectUrl: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** A placeholder query used by thecodingmachine/graphqlite when there are no declared subscriptions. */
  dummySubscription?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionOrderProxyType = {
  __typename?: 'SubscriptionOrderProxyType';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  status: SubscriptionOrderStatusEnum;
  yearly: Scalars['Boolean']['output'];
};

export enum SubscriptionOrderStatusEnum {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum SubscriptionPlanEnum {
  BusinessMonth = 'BUSINESS_MONTH',
  BusinessYear = 'BUSINESS_YEAR',
  ProMonth = 'PRO_MONTH',
  ProYear = 'PRO_YEAR',
  WlMonth = 'WL_MONTH',
  WlYear = 'WL_YEAR'
}

export type SubscriptionPlanPriceType = {
  __typename?: 'SubscriptionPlanPriceType';
  /** Цена в единицах валюты (не центах) */
  amount: Scalars['Float']['output'];
  /** Код валюты в нижнем регистре: usd, eur и т.д. */
  currency: Scalars['String']['output'];
  /**
   * Цена в пересчёте на месяц: для годовых планов amount / 12, для месячных равна amount.
   * Считается от итогового amount, т.е. уже с учётом промокод-скидки, если она применена.
   */
  monthlyAmount: Scalars['Float']['output'];
  /** Enum-значение плана: PRO_MONTH, PRO_YEAR, WL_MONTH, WL_YEAR, BUSINESS_MONTH, BUSINESS_YEAR */
  plan: Scalars['String']['output'];
  /** Человекочитаемое название: Pro, White Label, Business */
  planName: Scalars['String']['output'];
  yearly: Scalars['Boolean']['output'];
};

export type SubscriptionPromoCodeType = {
  __typename?: 'SubscriptionPromoCodeType';
  applicablePlans: Array<SubscriptionPlanEnum>;
  code: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  discountValue: Scalars['Float']['output'];
};

export type SubscriptionProxyType = {
  __typename?: 'SubscriptionProxyType';
  active: Scalars['Boolean']['output'];
  autoRenewal: Scalars['Boolean']['output'];
  canceled: Scalars['Boolean']['output'];
  dateOfEnd: Scalars['DateTime']['output'];
  dateOfStart: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  plan?: Maybe<Scalars['String']['output']>;
  status: SubscriptionStatusEnum;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  yearly: Scalars['Boolean']['output'];
};

export enum SubscriptionStatusEnum {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  CanceledImmediately = 'CANCELED_IMMEDIATELY',
  PaymentFailed = 'PAYMENT_FAILED'
}

export type SymfonyUserImpl = SymfonyUserInterface & {
  __typename?: 'SymfonyUserImpl';
  roles: Array<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type SymfonyUserInterface = {
  roles: Array<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type TicketGenerationJobProxyType = {
  __typename?: 'TicketGenerationJobProxyType';
  createdAt: Scalars['Int']['output'];
  /**
   * REST download URL (binary PDF/ZIP cannot go through GraphQL).
   * Null until the job has finished successfully.
   */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  eventStartDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  separate: Scalars['Boolean']['output'];
  status: TicketGenerationJobStatusEnum;
  ticketId?: Maybe<Scalars['Int']['output']>;
};

export enum TicketGenerationJobStatusEnum {
  Fail = 'FAIL',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export type TicketInfoType = {
  __typename?: 'TicketInfoType';
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  soldOut: Scalars['Int']['output'];
  ticketParticipant: Array<TicketParticipant>;
  ticketType?: Maybe<Scalars['String']['output']>;
};

export type TicketOfficeActionResponseType = {
  __typename?: 'TicketOfficeActionResponseType';
  order: TicketOfficePreOrderType;
  ticketStats: Array<TicketOfficeTicketStatsType>;
};

/**
 * Human-readable ticket office mode of a cash payment. Additive counterpart of
 * the legacy int field Payments::ticketOfficeType (0|1|2), which stays exposed
 * as-is for backward compatibility.
 */
export enum TicketOfficeModeEnum {
  GenerateTicket = 'GENERATE_TICKET',
  PreOrder = 'PRE_ORDER',
  ShowModal = 'SHOW_MODAL'
}

export type TicketOfficePreOrderPaginatedType = {
  __typename?: 'TicketOfficePreOrderPaginatedType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items: Array<TicketOfficePreOrderType>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TicketOfficePreOrderTicketType = {
  __typename?: 'TicketOfficePreOrderTicketType';
  quantity: Scalars['Int']['output'];
  typeName?: Maybe<Scalars['String']['output']>;
};

export type TicketOfficePreOrderType = {
  __typename?: 'TicketOfficePreOrderType';
  canceledPreOrder: Scalars['Boolean']['output'];
  createdAt: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  tickets: Array<TicketOfficePreOrderTicketType>;
  ticketsSentAt?: Maybe<Scalars['Int']['output']>;
};

export type TicketOfficeResponseType = {
  __typename?: 'TicketOfficeResponseType';
  cashInfoProxyType: EventCashInfoProxyType;
  paymentsProxyType: PaymentsProxyType;
};

export type TicketOfficeTicketStatsType = {
  __typename?: 'TicketOfficeTicketStatsType';
  availableForSale: Scalars['Int']['output'];
  preOrdered: Scalars['Int']['output'];
  sold: Scalars['Int']['output'];
  ticketId: Scalars['Int']['output'];
  typeName?: Maybe<Scalars['String']['output']>;
};

export type TicketParticipant = {
  __typename?: 'TicketParticipant';
  activatedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  participant?: Maybe<Participant>;
  status?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type TicketParticipantActivatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type TicketProxyType = {
  __typename?: 'TicketProxyType';
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTicketSales?: Maybe<Scalars['DateTime']['output']>;
  endTicketSalesUtc?: Maybe<Scalars['DateTime']['output']>;
  event: EventProxyType;
  id: Scalars['Int']['output'];
  isAfterApproved?: Maybe<Scalars['Boolean']['output']>;
  limitQuantity?: Maybe<Scalars['Int']['output']>;
  participantQuantity: Scalars['Int']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  startTicketSales?: Maybe<Scalars['DateTime']['output']>;
  startTicketSalesUtc?: Maybe<Scalars['DateTime']['output']>;
  ticketSalesInterval?: Maybe<Scalars['DateInterval']['output']>;
  totalBookedTickets: Scalars['Int']['output'];
  type: TicketTypeProxyType;
};

export type TicketReturnContactProxyType = {
  __typename?: 'TicketReturnContactProxyType';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  ticketReturn?: Maybe<TicketReturnProxyType>;
};

export type TicketReturnProxyType = {
  __typename?: 'TicketReturnProxyType';
  contacts: Array<TicketReturnContactProxyType>;
  description?: Maybe<Scalars['String']['output']>;
  event: EventProxyType;
  id: Scalars['Int']['output'];
  isPossible?: Maybe<Scalars['Boolean']['output']>;
};

export type TicketType = {
  __typename?: 'TicketType';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TicketTypeInput = {
  id: Scalars['Int']['input'];
};

export type TicketTypeProxyType = {
  __typename?: 'TicketTypeProxyType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  maxSoldTickets: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizer?: Maybe<OrganizerProxyType>;
};

export type Tickets = {
  __typename?: 'Tickets';
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  ticketParticipants?: Maybe<Array<TicketParticipant>>;
  ticketType?: Maybe<Scalars['String']['output']>;
};

export type TimeZone = {
  __typename?: 'TimeZone';
  id?: Maybe<Scalars['Int']['output']>;
};

export type TimezoneInput = {
  id: Scalars['Int']['input'];
};

export type TimezoneProxyType = {
  __typename?: 'TimezoneProxyType';
  gmt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Token = {
  __typename?: 'Token';
  token: Scalars['String']['output'];
};

export type TypeProxyType = {
  __typename?: 'TypeProxyType';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


export type TypeProxyTypeDescriptionArgs = {
  stripTags?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Types = {
  __typename?: 'Types';
  id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type UpdateOrganizerProfileTypeInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  frequencySaleNotificationId?: InputMaybe<Scalars['Int']['input']>;
  lastName: Scalars['String']['input'];
  messengerId?: InputMaybe<Scalars['Int']['input']>;
  messengerUserName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizerPromoCodeTypeInput = {
  code: Scalars['String']['input'];
  discountValue: Scalars['Int']['input'];
  eventIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  expirationDate: Scalars['DateTime']['input'];
  minimumOrderAmount?: InputMaybe<Scalars['Float']['input']>;
  usageLimit: Scalars['Int']['input'];
};

export type UserPasswordTypeInput = {
  newPassword?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfileTypeInput = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  messengerId?: InputMaybe<Scalars['Int']['input']>;
  messengerUsername?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type UserProxyType = {
  __typename?: 'UserProxyType';
  country?: Maybe<CountryProxyType>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messengerUserName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  tickets: OrderTicketDataPaginatedType;
  username?: Maybe<Scalars['String']['output']>;
  wishLists: Array<WishListProxyType>;
};


export type UserProxyTypeTicketsArgs = {
  filter?: InputMaybe<UserTicketFilterEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type UserShareEventType = {
  __typename?: 'UserShareEventType';
  event: Event;
  userShareToken: Scalars['String']['output'];
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  artists: Array<Performer>;
  categories: Array<Category>;
  email?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isSubscribe?: Maybe<Scalars['Boolean']['output']>;
  lastIp?: Maybe<Scalars['String']['output']>;
  lastSend?: Maybe<Scalars['DateTime']['output']>;
  selectedCountry?: Maybe<Country>;
};

export enum UserTicketFilterEnum {
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export type UserTicketPaginatedType = {
  __typename?: 'UserTicketPaginatedType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items: Array<UserTicketType>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserTicketType = {
  __typename?: 'UserTicketType';
  address?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  eventImagePath?: Maybe<Scalars['String']['output']>;
  eventTitle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  ticketType?: Maybe<Scalars['String']['output']>;
};

export type UserType = {
  __typename?: 'UserType';
  country?: Maybe<Country>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  userSubscription?: Maybe<UserSubscription>;
};

export type Venue = {
  __typename?: 'Venue';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  id?: Maybe<Scalars['Int']['output']>;
  place?: Maybe<Scalars['String']['output']>;
};

export type Visual = {
  __typename?: 'Visual';
  fileName?: Maybe<Scalars['String']['output']>;
  formattedPath?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type WhiteLabelAccessType = {
  __typename?: 'WhiteLabelAccessType';
  canAccessSettingsPreview: Scalars['Boolean']['output'];
  canCustomizeBranding: Scalars['Boolean']['output'];
  canManageWhiteLabel: Scalars['Boolean']['output'];
  canRemoveMeTicketBranding: Scalars['Boolean']['output'];
  canUseCustomDomain: Scalars['Boolean']['output'];
  canUseTicketSubdomain: Scalars['Boolean']['output'];
  requiresPoweredByBranding: Scalars['Boolean']['output'];
};

export type WhiteLabelBannerImageProxyType = {
  __typename?: 'WhiteLabelBannerImageProxyType';
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  link: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  whiteLabelConfig?: Maybe<WhiteLabelConfigProxyType>;
};

export type WhiteLabelBannersType = {
  __typename?: 'WhiteLabelBannersType';
  file: Scalars['Upload']['output'];
  id?: Maybe<Scalars['Int']['output']>;
};

export type WhiteLabelBannersTypeInput = {
  file: Scalars['Upload']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type WhiteLabelConfigImageProxyType = {
  __typename?: 'WhiteLabelConfigImageProxyType';
  fileName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  link: Scalars['String']['output'];
  path: Scalars['String']['output'];
  whiteLabelConfig: WhiteLabelConfigProxyType;
};

export type WhiteLabelConfigProxyType = {
  __typename?: 'WhiteLabelConfigProxyType';
  buttonColor?: Maybe<Scalars['String']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  favicon?: Maybe<ImageProxyType>;
  id: Scalars['Int']['output'];
  instagramLink?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Scalars['String']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  showNewEvents: Scalars['Boolean']['output'];
  showPopularPerformers: Scalars['Boolean']['output'];
  showUpcomingEvents: Scalars['Boolean']['output'];
  siteLogo?: Maybe<ImageProxyType>;
  tikTok?: Maybe<Scalars['String']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  whiteLabel: WhiteLabelProxyType;
  whiteLabelBannerImages: Array<WhiteLabelBannerImageProxyType>;
  youtubeLink?: Maybe<Scalars['String']['output']>;
};

export type WhiteLabelConfigType = {
  __typename?: 'WhiteLabelConfigType';
  buttonColor?: Maybe<Scalars['String']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  instagramLink?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  showNewEvents: Scalars['Boolean']['output'];
  showPopularPerformers: Scalars['Boolean']['output'];
  showUpcomingEvents: Scalars['Boolean']['output'];
  twitterLink?: Maybe<Scalars['String']['output']>;
  youtubeLink?: Maybe<Scalars['String']['output']>;
};

export type WhiteLabelGeneralInformationType = {
  __typename?: 'WhiteLabelGeneralInformationType';
  projectName?: Maybe<Scalars['String']['output']>;
  showNewEvents: Scalars['Boolean']['output'];
  showPopularPerformers: Scalars['Boolean']['output'];
  showUpcomingEvents: Scalars['Boolean']['output'];
};

export type WhiteLabelGeneralInformationTypeInput = {
  isShowNewEvents: Scalars['Boolean']['input'];
  isShowPopularPerformers: Scalars['Boolean']['input'];
  isShowUpcomingEvents: Scalars['Boolean']['input'];
  projectName: Scalars['String']['input'];
};

export type WhiteLabelLimitInfoType = {
  __typename?: 'WhiteLabelLimitInfoType';
  activeCount: Scalars['Int']['output'];
  /** Null means unlimited (Business subscription). */
  limit?: Maybe<Scalars['Int']['output']>;
  limitReached: Scalars['Boolean']['output'];
};

export type WhiteLabelProjectMediaType = {
  __typename?: 'WhiteLabelProjectMediaType';
  bannersDeleted: Array<Scalars['Int']['output']>;
  bannersInput: Array<WhiteLabelBannersType>;
  buttonColor?: Maybe<Scalars['String']['output']>;
  favicon?: Maybe<Scalars['Upload']['output']>;
  siteLogo?: Maybe<Scalars['Upload']['output']>;
};

export type WhiteLabelProjectMediaTypeInput = {
  bannersDeleted: Array<Scalars['Int']['input']>;
  bannersInput: Array<WhiteLabelBannersTypeInput>;
  buttonColor?: InputMaybe<Scalars['String']['input']>;
  favicon?: InputMaybe<Scalars['Upload']['input']>;
  siteLogo?: InputMaybe<Scalars['Upload']['input']>;
};

export type WhiteLabelProxyType = {
  __typename?: 'WhiteLabelProxyType';
  domain?: Maybe<Scalars['String']['output']>;
  domainStatus?: Maybe<DomainStatus>;
  domainType?: Maybe<DomainType>;
  id: Scalars['Int']['output'];
  organizer?: Maybe<OrganizerProxyType>;
  projectName?: Maybe<Scalars['String']['output']>;
  whiteLabelConfig?: Maybe<WhiteLabelConfigProxyType>;
};

export type WhiteLabelSeoSettingsType = {
  __typename?: 'WhiteLabelSEOSettingsType';
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
};

export type WhiteLabelSeoSettingsTypeInput = {
  keywords?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
};

export type WhiteLabelSocialLinksType = {
  __typename?: 'WhiteLabelSocialLinksType';
  facebookLink?: Maybe<Scalars['String']['output']>;
  instagramLink?: Maybe<Scalars['String']['output']>;
  linkedInLink?: Maybe<Scalars['String']['output']>;
  tikTokLink?: Maybe<Scalars['String']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  youtubeLink?: Maybe<Scalars['String']['output']>;
};

export type WhiteLabelSocialLinksTypeInput = {
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  linkedInLink?: InputMaybe<Scalars['String']['input']>;
  tikTokLink?: InputMaybe<Scalars['String']['input']>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type WishListProxyType = {
  __typename?: 'WishListProxyType';
  event?: Maybe<EventProxyType>;
  id?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<UserProxyType>;
};

export type Wishlist = {
  __typename?: 'Wishlist';
  event?: Maybe<Event>;
  id?: Maybe<Scalars['Int']['output']>;
};
